import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import { JsonFieldType } from '../../../types';
import type { ITableComponentProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<ITableComponentProps>>
): IComponentSchema<ITableComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Table',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Table,
    'x-component-props': {
      columns: {} as any,
      data: [],
      rowItemName: 'row',
    },
    'x-component-props-config': {
      data: {
        type: ComponentConfigType.Variable,
      },
    },
  };
};
